import styled from "styled-components";

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 2rem;

  .title {
    color: var(--color-yellow);
    font-size: 32px;
    font-weight: 600;
    text-align: center;

    @media (min-width: 1024px) {
      
      margin-left: 4rem;
      text-transform: uppercase;
    }
  }
`;
export const ServiceContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 2rem;
`;
